import { renderPetName } from './renderPetName';

export const drawCanvas = ({
  canvas,
  images,
  staticBg,
  frameImage,
  imageCache,
  selectedFrame,
  includePetName,
  petName,
  isDragging,
  customPetNameColor,
  customPetNamePosition
}) => {
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Draw static background
  if (staticBg) {
    ctx.drawImage(staticBg, 0, 0, canvas.width, canvas.height);
  }

  // Draw uploaded images
  images.forEach((img) => {
    const imgElement = imageCache.current.get(img.id);
    if (imgElement) {
      ctx.save();
      ctx.translate(img.x + img.width / 2, img.y + img.height / 2);
      ctx.rotate((img.rotation * Math.PI) / 180);
      ctx.scale(img.scale, img.scale);
      ctx.drawImage(imgElement, -img.width / 2, -img.height / 2, img.width, img.height);
      ctx.restore();
    }
  });

  // Draw frame overlay
  if (frameImage) {
    ctx.globalAlpha = isDragging ? 0.6 : 1.0;
    ctx.drawImage(frameImage, 0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = 1.0;
  }

  // Draw pet name
  if (includePetName) {
    renderPetName(ctx, canvas, selectedFrame, petName, customPetNameColor, customPetNamePosition);
  }
};
